<div class="container">
  <app-header-actions
    [headerTitle]="'BENCHMARK.TITLE'"
    [headerIcon]="faDatabase"
    [config]="headerConfig"
    [count]="benchmarks.length + ' ' + ('BENCHMARK.TITLE' | translate)"
    [showCount]="false"
    (addClick)="onUploadClick()"
    (backClick)="onBack()">
  </app-header-actions>

  <app-item-list
    [items]="benchmarksAsListItems"
    [loading]="loading"
    [config]="listConfig"
    (actionClick)="onItemAction($event)"
    (itemClick)="onItemClick($event)">
  </app-item-list>

  <app-modal-delete-confirm
    [show]="showDeleteModal"
    [configKey]="benchmarkToDelete?.name || ''"
    [configType]="'BENCHMARK.TITLE' | translate"
    (close)="onDeleteClose()"
    (confirm)="onDeleteConfirm()">
  </app-modal-delete-confirm>

  <app-modal-rename-confirm
    [show]="showRenameModal"
    [loading]="loading"
    [itemName]="benchmarkToRename?.name || ''"
    [initialValue]="benchmarkToRename?.name || ''"
    (close)="onRenameClose()"
    (confirm)="onRenameConfirm($event)">
  </app-modal-rename-confirm>

  <input
    type="file"
    #fileInput
    style="display: none"
    (change)="onFileSelected($event)" />
</div>
